module.exports = __webpack_public_path__ + "img/13.9f7db2ed.png";